<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10SrBLd/tc-custom/9781442213692.jpg?1726454431589" alt="This image is the cover for the book Martin Buber's Spirituality"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Martin Buber's Spirituality
      </h1>
      <p class="bookDescription body article font2">
        <p>How do we find meaning in our life? This book explores how Martin Buber, one of the 20th century’s greatest religious thinkers, answers this timeless question. Author Kenneth Paul Kramer explains Buber’s Hasidic spirituality—a living connection between the human and the divine—and how it is relevant to all spiritual seekers.    According to Buber, we find meaning in life through wholeheartedly “letting God in." He developed this theme through six thought-provoking talks originally published as The Way of Man. In Martin Buber’s Spirituality, Kramer explains the accessible practices Buber outlined in these talks, shares the stories Buber used to illustrate each point, and explores how these teachings might apply in everyday life today.   The book features questions for personal or group reflection to help readers more fully explore Martin Buber’s approach to spirituality, along with a glossary of key terms.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kenneth Paul Kramer
      </h2>
      
      <p class="authorDescription body article">Kenneth Paul Kramer is the author of several books, including Martin Buber’s I and Thou: Practicing Living Dialogue. He is professor emeritus of comparative religious studies at San Jose State University and lives in Santa Cruz, CA</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ROWMAN & LITTLEFIELD PUBLISHERS, INC.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a8c03e6